export const BusySlot = Object.freeze({
	OffHours: 'offHours',
	Intersection: 'intersection',
	IntersectionOverbooking: 'intersection-overbooking',
});
